/**
 * created by mgg and fxd
 *维护字段
 */
import React, {Component} from "react";
import {
    Button,
    Icon,
    Input,
    Table,
    Switch,
    Modal,
    Popconfirm,
    Form,
    Select,
    InputNumber,
    Menu,
    Dropdown,
    Divider
} from "antd";
import {message} from "../../../sysManagement/utils/sysManagementUtils";
import SpacerBlock from "../../../components/spacerBlock/SpacerBlock";
import {Prompt} from "react-router-dom";
import "./MaintenanceField.css";
import {
    getNewMediaFields,
    saveAllNewMediaFields,
    recoverToDefault,
    batchDeleteNewMediaField,
    preDeleteNewMediaField,
    preEditNewMediaField
} from "../../actions/platformMaintenance";
import {uuid} from "../../../../utils";
import {getInfoFromLocalStorage} from "../../../../actions";
import {Scrollbars} from "react-custom-scrollbars";
import BaseComponent from "../../../../base/BaseComponent";

const {TextArea} = Input;
const {Option} = Select;
const {confirm} = Modal;
const NewMediaFieldTypeEnum = [
    {
        key: 1,
        label: "文本框"
    },
    {
        key: 2,
        label: "文本域"
    },
    {
        key: 3,
        label: "单选下拉框"
    },
    {
        key: 4,
        label: "复选下拉框"
    },
    {
        key: 5,
        label: "日期选择器"
    }
];

export default class MaintenanceField extends BaseComponent {
    constructor(props) {
        super(props);
        const newMediaTypeId = props.match.params.id;
        this.state = {
            newMediaTypeId,//平台id
            dataSource: [],//数据源
            dataSourceHold: [],//暂存数据
            dataSourceEdit: [],//编辑中的数据
            editingIds: [],//正在编辑的行
            addingIds: [],//添加中的行
            editPropertyVisible: false,//编辑属性弹框
            editPropertyId: "",
            editIds: [],//收集数据
            // 编辑属性弹窗的数据
            fieldName: "",
            fieldType: 1,    //字段类型
            ruleType: null,   //字段限制规则
            length: 0,
            contentTypes: [],   //限制内容
            keyValueMapsArr: [], //  键、值
            prohibitExit: false,
            platformName: "", //平台名称
            visible: false
        };
    }


    componentDidMount() {
        this.getList();
        let params = getInfoFromLocalStorage("MaintenanceField");
        if (params) {
            this.state.platformName = params.name;
        }
    }

    render() {
        const columns = [
            {
                title: "字段名称",
                dataIndex: "fieldName",
                key: "fieldName",
                width: 200,
                render: (text, record) => {
                    const isEditing = this.isEditing(record.id);
                    const currentEdit = this.currentEditData(record);
                    if (isEditing) {
                        return (
                            <Form.Item
                                // validateStatus={currentEdit.fieldName === "" ? "error" : ""}
                                // help={currentEdit.fieldName === "" ? "字段名称不能为空" : ""}
                            >
                                <Input
                                    style={{background: "rgba(246, 248, 253, 0.86)", opacity: 1,transform:"translateY(10px)"}}
                                    value={currentEdit.fieldName}
                                    onChange={(e) => {
                                        currentEdit.fieldName = e.target.value.trim();
                                        this.setState({});
                                    }}
                                    // onFocus={()=> this.focusFieldName(currentEdit)}
                                />
                            </Form.Item>);
                    } else {
                        return text;
                    }
                }
            },
            {
                title: "键",
                dataIndex: "dbFieldName",
                key: "dbFieldName",
                width: 200,
                render: (text, record) => {
                    const isEditing = this.isEditing(record.id);
                    const currentEdit = this.currentEditData(record);
                    if (isEditing && currentEdit.defaultField) {
                        return (
                            <Form.Item
                                // validateStatus={currentEdit.dbFieldName === "" ? "error" : ""}
                                // help={currentEdit.dbFieldName === "" ? "键不能为空" : ""}
                            >
                                <Input
                                    style={{background: "rgba(246, 248, 253, 0.86)", opacity: 1,transform:"translateY(10px)"}}
                                    value={currentEdit.dbFieldName}
                                    onChange={(e) => {
                                        currentEdit.dbFieldName = e.target.value.trim();
                                        this.setState({});
                                    }}
                                    // onFocus={()=> this.focusKey(currentEdit)}
                                />
                            </Form.Item>);
                    } else {
                        return text;
                    }
                }
            },
            {
                title: "类型",
                // dataIndex: "fieldFillRules[0].fieldType",
                key: "fieldFillRulesFieldType",
                align: "center",
                width: 160,
                render: (text, record) => {
                    let type;
                    try {
                        type = record.fieldType;
                    } catch (e) {
                        type = 0;
                    }
                    return this.parseType(type);
                }
            },
            {
                title: "字段提示",
                dataIndex: "fieldTip",
                key: "fieldTip",
                align: "center",
                width: 200,
                ellipsis: true,
                render: (text, record) => {
                    const isEditing = this.isEditing(record.id);
                    const currentEdit = this.currentEditData(record);
                    if (isEditing) {
                        return <TextArea
                            rows={1}
                            style={{background: "rgba(246, 248, 253, 0.86)", opacity: 1}}
                            value={currentEdit.fieldTip}
                            onChange={e => {
                                currentEdit.fieldTip = e.target.value.trim();
                                this.setState({});
                            }}
                        />;
                    } else {
                        return text;
                    }
                }
            },
            {
                title: "必填",
                dataIndex: "required",
                key: "required",
                align: "center",
                render: (text, record) => {
                    const isEditing = this.isEditing(record.id);
                    const currentEdit = this.currentEditData(record);
                    return <Switch
                        checkedChildren="是"
                        unCheckedChildren="否"
                        checked={isEditing ? currentEdit.required === 0 : record.required === 0}
                        disabled={!isEditing}
                        onChange={(checked) => {
                            currentEdit.required = checked ? 0 : 1;
                            this.setState({});
                        }}
                    />;
                }
            },
            {
                title: "开启状态",
                dataIndex: "status",
                key: "status",
                align: "center",
                render: (text, record) => {
                    const isEditing = this.isEditing(record.id);
                    const currentEdit = this.currentEditData(record);
                    return <Switch
                        checkedChildren="开"
                        unCheckedChildren="关"
                        checked={isEditing ? currentEdit.status === 1 : record.status === 1}
                        disabled={!isEditing}
                        onChange={(checked) => {
                            currentEdit.status = checked ? 1 : 0;
                            this.setState({});
                        }}
                    />;
                }
            },
            {
                title: "操作",
                dataIndex: "operation",
                key: "operation",
                width: 200,
                render: (text, record) => {
                    console.log(record);
                    const editable = this.isEditing(record.id);
                    return editable ? (
                            <div className="operate_btns">
                                <span style={{color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}} onClick={() => this.saveEdit(record.id)}>确认</span>
                                <span style={{color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}} onClick={() => this.cancelEdit(record.id)}>取消</span>
                            </div>
                        ) :
                        (
                            <div className="operate_btns">
                                <span onClick={() => this.editRowHandle(record)} style={{color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}}>编辑</span>
                                {((record.defaultField || record.dbFieldName === "grade") && record.fieldType !== 5) ?
                                    <span onClick={() => this.editProperty(record)} style={{color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}}>编辑属性</span> : null}
                                {
                                    record.defaultField ?
                                        <Popconfirm
                                            title="删除这行数据?"
                                            onConfirm={() => this.delCell(record.id)}
                                            okText="确定"
                                            cancelText="取消"
                                        >
                                            <span className="del">删除</span>
                                        </Popconfirm> : null}
                            </div>
                        );
                }
            }
        ];
        let {
            fieldName,
            fieldType,
            ruleType,
            length,
            contentTypes,
            keyValueMapsArr,
            editPropertyVisible,
            editPropertyId,
            prohibitExit
        } = this.state;
        // const options = ["不限制", "中文", "字母", "数字"];
        const options = [
            {
                key: -1,
                value: "不限制"
            },
            {
                key: 2,
                value: "中文"
            },
            {
                key: 0,
                value: "字母"
            },
            {
                key: 1,
                value: "数字"
            }
        ];
        const menu = (
            <Menu onClick={this.handleMenuClick} onMouseLeave={() => {this.setState({visible: false})}}>
                <Menu.Item key={1}>文本框</Menu.Item>
                <Menu.Item key={2}>文本域</Menu.Item>
                <Menu.Item key={3}>单选下拉框</Menu.Item>
                <Menu.Item key={4}>复选下拉框</Menu.Item>
                <Menu.Item key={5}>日期选择器</Menu.Item>
            </Menu>
        );
        return (
            <div>
                <Prompt when={prohibitExit} message={() => "\n检测到当前有操作没有保存，退出后当前修改数据将会丢失。\n\n是否强制退出！"}/>
                <div style={{padding: 20, background: "#fff"}}>
                    <div style={{
                        padding: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <div style={{fontSize: 16, color: "#222"}}>平台维护-{this.state.platformName}</div>
                        <div>当前位置： 平台维护
                            <span style={{margin: "0px 6px"}}>{">"}</span>
                            <span style={{color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")}}> 维护字段</span>
                            <span style={{margin: "0px 10px"}}>|</span>
                            <span
                                onClick={() => this.props.history.push("/view/newMediaMatrix/pms/platformMaintenance/platformMaintenance")}
                                style={{color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"), cursor: "pointer"}}>
                            返回上一级
                        </span>
                        </div>
                    </div>
                    <SpacerBlock height={1}/>
                </div>
                <div id="user_custom_table">
                    <Scrollbars autoHeight autoHeightMax={620}>
                        <Table
                            dataSource={this.state.dataSourceHold}
                            columns={columns}
                            pagination={false}
                            rowClassName={this.getRowClassName}
                            rowKey="id"
                        />
                    </Scrollbars>
                    <style>{`
                    #user_custom_table .ant-table-row:nth-child(2n) {
                        background-color: rgba(245, 248, 252, 1);
                    }
                `}</style>
                    {/*<Divider/>*/}
                    <Dropdown overlayClassName={"dropDown"} trigger={["click"]} overlay={menu} placement="bottomCenter"
                              onVisibleChange={(flag)=>{this.setState({ visible: flag });}}
                              visible={this.state.visible}
                    >
                        <div onClick={(e) => {
                            e.preventDefault();
                        }} style={{
                            textAlign: "center",
                            width: "100%",
                            border: "1px dashed #ccc",
                            padding: "5px 0px",
                            cursor: "pointer",
                            marginTop: "10px"
                        }}>
                            <Icon style={{marginRight: "10px", fontSize: 10}} type={"plus"}/>添加
                        </div>
                    </Dropdown>
                    <Modal
                        title="编辑属性"
                        visible={editPropertyVisible}
                        onCancel={() => this.cancelModal(editPropertyId)}
                        onOk={() => this.saveProperty(editPropertyId)}
                        centered={true}
                        width={1000}
                        className="field_modal"
                    >
                        <Form labelCol={{span: 3}} wrapperCol={{span: 19}}>
                            <Form.Item label="字段名称">
                                <div>{fieldName}</div>
                            </Form.Item>
                            <Form.Item label="字段类型" required>
                                <Input placeholder={this.parseType(fieldType)} disabled={true} style={{border:"none"}}></Input>
                            </Form.Item>
                            {
                                //文本框和文本域
                                fieldType === 1 || fieldType === 2 ?
                                    <>
                                        <Form.Item label="限制字符数">
                                            <InputNumber
                                                precision={1}
                                                min={0}
                                                step={1}
                                                formatter={v => isNaN(v) ? 0 : v * 1}
                                                value={length}
                                                onChange={e => this.setState({length: e || 0})}
                                            />
                                            <span>填写"0"则为不限制</span>
                                        </Form.Item>
                                        <Form.Item label="限制内容">
                                            <Select
                                                mode="multiple"
                                                placeholder="请选择"
                                                value={contentTypes}
                                                onChange={value => {
                                                    // 如果最后一个是限制，只保留限制
                                                    if (value[value.length - 1] === -1) {
                                                        value = [-1];
                                                    } else if (value[0] === -1 && value.length > 1) {
                                                        // 如果限制后面再添加  删除限制
                                                        value.shift();
                                                    }
                                                    this.setState({contentTypes: value});
                                                }
                                                }
                                            >
                                                {options.map(item => <Option value={item.key}
                                                                             key={item.key}>{item.value}</Option>)}
                                            </Select>
                                        </Form.Item>
                                    </> :
                                    fieldType === 3 || fieldType === 4 ?
                                        <ul className="property_list_wrap">
                                            <li className="property_list_item" id="property_list_itemOne">
                                                <span>键</span>
                                                <span>值</span>
                                                <div>
                                                    <img src='images/add.png'
                                                         onClick={() => this.setState({
                                                             keyValueMapsArr: [...keyValueMapsArr, {
                                                                 key: "",
                                                                 value: "",
                                                                 id: Math.random()
                                                             }]
                                                         })}
                                                    />
                                                </div>
                                            </li>
                                            {
                                                keyValueMapsArr.map(item => {
                                                    return <li className="property_list_item"
                                                               key={item.id}>
                                                        <Input
                                                            placeholder="请输入"
                                                            value={item.key}
                                                            onChange={(e) => {
                                                                item.key = e.target.value;
                                                                this.setState({});
                                                            }}/>
                                                        <Input
                                                            placeholder="请输入"
                                                            value={item.value}
                                                            onChange={(e) => {
                                                                item.value = e.target.value;
                                                                this.setState({});
                                                            }}/>
                                                        <div>
                                                            <img src='images/delete.png' onClick={() => {
                                                                this.setState({
                                                                    keyValueMapsArr: keyValueMapsArr.filter(prop => {
                                                                        return item.id !== prop.id;
                                                                    })
                                                                });
                                                            }}/>
                                                        </div>
                                                    </li>;
                                                })
                                            }
                                        </ul> :
                                        <></>
                            }
                        </Form>
                    </Modal>
                </div>
                <div id={"mainteranceField"} style={{backgroundColor: "#fff"}}>
                    <Divider/>
                    <div style={{justifyContent: "center", display: "flex", alignItems: "center", paddingBottom: 15}}>
                        <Button onClick={() => this.goBack()}>返回</Button>
                        <Button onClick={() => this.restoreData()}>恢复默认</Button>
                        <Button onClick={() => this.saveAll()} type="primary">保存</Button>
                    </div>
                </div>
                <style>{`
                #mainteranceField .ant-divider-horizontal{margin: 0px 0px 15px 0px !important;}
                #mainteranceField button{margin: 0 10px;}
                `}</style>
            </div>
        );
    }

    handleMenuClick = ({key}) => {
        this.setState({
            visible: false,
            fieldType: parseInt(key)
        },()=>{
            this.addField();
        })
    }

    // 行是否正在编辑
    isEditing = (id) => {
        return this.inEditingIds(id) || this.inAddingIds(id);
    };

    // 编辑中的ids
    inEditingIds = (id) => this.state.editingIds.includes(id);

    // 添加中的ids
    inAddingIds = (id) => this.state.addingIds.includes(id);

    //获取焦点时字段名称自动清空
    focusFieldName(currentEdit){
        if(this.inAddingIds(currentEdit.id)){
            currentEdit.fieldName ="";
        }
        this.setState({})
    }
    //获取焦点时键默认值自动清空
    focusKey(currentEdit){
        if(this.inAddingIds(currentEdit.id)){
            currentEdit.dbFieldName ="";
        }
        this.setState({})
    }

    //点击添加按钮
    addField = () => {
        const {newMediaTypeId, fieldType} = this.state;
        const id = uuid();
        const defaultLine = {
            id: id,
            fieldName: "字段名称",
            dbFieldName: "键",
            fieldTip: "",
            required: 1,
            defaultField: 1,
            status: 1,
            fieldType,
            newMediaTypeId,
            fieldFillRules: [
                {
                    fieldType,
                    ruleType: 0,
                    length: 0,
                    contentTypes: [],
                    keyValueMaps: {}
                }
            ]
        };
        this.state.dataSourceHold.push((JSON.parse(JSON.stringify(defaultLine))));
        this.state.dataSourceEdit.push((JSON.parse(JSON.stringify(defaultLine))));
        this.state.addingIds.push(id);
        this.setState({});
    };

    // 点击编辑
    editRowHandle(record) {
        this.state.editingIds.push(record.id);
        this.setState({});
    };

    //保存属性类型
    saveProperty = (id) => {
        const {
            dataSourceEdit,
            dataSourceHold,
            fieldType,
            ruleType,
            length,
            contentTypes,
            keyValueMapsArr,
            editIds
        } = this.state;
        // 数据校验
        // 键值对数据校验
        for (let i = 0; i < keyValueMapsArr.length; i++) {
            const mapItem = keyValueMapsArr[i];
            if (!mapItem.value.trim() || !mapItem.key.trim()) {
                return message.warn("下拉框的键-值不能为空！");
            }
        }

        const editItem = dataSourceEdit.find(item => item.id === id);
        preEditNewMediaField(editItem,res=>{
            if(res){
                let fieldFillRule = [];
                if (fieldType === 1 || fieldType === 2) {
                    let arrayRule = [];//字符数>0,限制内容也选了就有1 限制规则数组
                    if (length > 0) {
                        //小于0 不添加限制
                        arrayRule.push(0);
                    }
                    if (contentTypes.length) {
                        arrayRule.push(1);
                    }
                    arrayRule.forEach(itemRule => {
                        if (itemRule == 0 && length > 0) {
                            fieldFillRule.push({
                                length,
                                ruleType: 0,
                                fieldType,
                                keyValueMaps: {}
                            });
                        }
                        if (itemRule == 1) {
                            fieldFillRule.push({
                                contentTypes,
                                ruleType: 1,
                                fieldType,
                                keyValueMaps: {}
                            });
                        }
                    });
                } else if (fieldType === 3) {
                    fieldFillRule = [{
                        fieldType,
                        ruleType: 2,
                        length: 0,
                        contentTypes: [],
                        keyValueMaps: this.parseKeyValueMapsArr(keyValueMapsArr)
                    }];
                } else if (fieldType === 4) {
                    fieldFillRule = [{
                        fieldType,
                        ruleType: 3,
                        length: 0,
                        contentTypes: [],
                        keyValueMaps: this.parseKeyValueMapsArr(keyValueMapsArr)
                    }];
                } else {
                    fieldFillRule = [{
                        fieldType,
                        ruleType: 4,
                        length: 0,
                        contentTypes: [],
                        keyValueMaps: {}
                    }];
                }
                editItem.fieldFillRules = fieldFillRule;
                editItem.fieldType = fieldType;
                const holdIndex = dataSourceHold.findIndex(item => item.id === id);
                dataSourceHold[holdIndex] = editItem;
                dataSourceEdit[holdIndex]=editItem
                this.setState({
                    editIds: editIds.includes(id) ? [...editIds] : [...editIds, id],
                    editPropertyVisible: false,
                    editPropertyId: "",
                    fieldName: "",
                    fieldType: 1,
                    ruleType: 0,
                    length: 0,
                    contentTypes: [],
                    keyValueMapsArr: [],
                    prohibitExit: true
                });
            }
        })

    };


    //编辑属性类型
    editProperty(record) {
        const {
            dataSourceEdit
        } = this.state;
        const current = dataSourceEdit.find(item => item.id === record.id);
        const {
            id,
            fieldName,
            fieldFillRules
        } = current;
        let fieldType=1,ruleType=[],length=0,keyValueMaps={}
        if(fieldFillRules[0]){
            fieldType= fieldFillRules[0].fieldType
            ruleType= fieldFillRules[0].ruleType
            length= fieldFillRules[0].length
            keyValueMaps= fieldFillRules[0].keyValueMaps
        }
        let contentTypes = this.state.contentTypes;
        fieldFillRules.forEach(item => {
            if (item.ruleType === 1) {
                contentTypes = item.contentTypes;
            }
        });
        this.setState({
            editPropertyVisible: true,
            editPropertyId: id,
            fieldName,
            fieldType,
            ruleType,
            length,
            contentTypes,
            keyValueMapsArr: this.parseKeyValueMaps(keyValueMaps)
        });
    };

    //取消编辑属性
    cancelModal(id) {
        const {
            dataSourceEdit,
            dataSourceHold
        } = this.state;
        const editItemIndex = dataSourceEdit.findIndex(item => item.id === id);
        dataSourceEdit[editItemIndex] = JSON.parse(JSON.stringify(dataSourceHold.find(item => item.id === id)));
        this.setState({
            editPropertyVisible: false,
            editPropertyId: "",
            fieldName: "",
            fieldType: 1,
            ruleType: 0,
            length: 0,
            contentTypes: [],
            keyValueMapsArr: []
        });
    };

    //保存编辑
    saveEdit = (id) => {
        const {
            dataSourceEdit,
            dataSourceHold,
            addingIds,
            editingIds,
            editIds
        } = this.state;
        const editItem = dataSourceEdit.find(item => item.id === id);
        if (!editItem.fieldName) {
            message.warn("字段名称不能为空");
            return false;
        } else if (!editItem.dbFieldName) {
            message.warn("键不能为空");
            return false;
        }
        preEditNewMediaField(editItem, res => {
            if (res) {
                const holdItemIndex = dataSourceHold.findIndex(item => item.id === id);
                dataSourceHold[holdItemIndex] = JSON.parse(JSON.stringify(editItem));
                this.setState({
                    addingIds: addingIds.filter(item => item !== id),
                    editingIds: editingIds.filter(item => item !== id),
                    editIds: editIds.includes(id) ? [...editIds] : [...editIds, id],
                    prohibitExit: true
                });
            }
        });
    };

    //取消编辑
    cancelEdit = (id) => {
        // 通过暂存数据  复原编辑数据
        // 删除 editingIds addingIds 中的id
        let {
            dataSourceEdit,
            dataSourceHold,
            addingIds,
            editingIds
        } = this.state;
        if (this.inAddingIds(id)) {
            // 如果是添加  直接删除
            this.setState({
                dataSourceEdit: dataSourceEdit.filter(item => item.id !== id),
                dataSourceHold: dataSourceHold.filter(item => item.id !== id),
                addingIds: addingIds.filter(item => item !== id)
            });
        } else {
            const editItemIndex = dataSourceEdit.findIndex(item => item.id === id);
            dataSourceEdit[editItemIndex] = JSON.parse(JSON.stringify(dataSourceHold.find(item => item.id === id)));
            this.setState({
                editingIds: editingIds.filter(item => item !== id)
            });
        }
    };

    //删除行
    delCell = (id) => {
        const {newMediaTypeId} = this.state;
        //删除前置接口  判断是否允许删除
        preDeleteNewMediaField({newMediaFieldDefineId: id, newMediaTypeId}, res => {
            if (res) {
                // 删除行 删除暂存和编辑里面的行
                let {
                    dataSourceEdit,
                    dataSourceHold
                } = this.state;
                this.setState({
                    dataSourceEdit: dataSourceEdit.filter(item => item.id !== id),
                    dataSourceHold: dataSourceHold.filter(item => item.id !== id),
                    prohibitExit: true
                });
            }
        });
    };

    //解析类型
    parseType = (type) => {
        let typeString = "";
        for (let i = 0; i < NewMediaFieldTypeEnum.length; i++) {
            const item = NewMediaFieldTypeEnum[i];
            if (item.key === type) {
                typeString = item.label;
                break;
            }
        }
        return typeString;
    };

    //获取数据
    getList() {
        const {newMediaTypeId} = this.state;
        getNewMediaFields(
            {newMediaTypeId},
            data => {
                const dataJSON = JSON.stringify(data);
                this.setState({
                    dataSource: JSON.parse(dataJSON),
                    dataSourceHold: JSON.parse(dataJSON),//暂存数据
                    dataSourceEdit: JSON.parse(dataJSON)//正在编辑数据
                });
            }
        );
    }

    //当前的编辑属性
    currentEditData = (record) => {
        const id = record.id;
        const {dataSourceEdit} = this.state;
        for (let i = 0; i < dataSourceEdit.length; i++) {
            const item = dataSourceEdit[i];
            if (id === item.id) {
                return item;
            }
        }
    };

    //返回
    goBack() {
        const {
            editingIds,
            addingIds
        } = this.state;
        if (editingIds.length || addingIds.length) {
            console.log("当前表格正在编辑");
        }
        this.props.history.push("/view/newMediaMatrix/pms/platformMaintenance/platformMaintenance");
    };

    //恢复数据
    //自定义的删掉
    // 所有内置字段还原
    restoreData() {
        const {newMediaTypeId} = this.state;
        confirm({
            title: "是否恢复默认？",
            content: "数据即将恢复到默认配置，自定义字段数据将被删除，内置字段数据将被还原",
            onOk: () => {
                this.setState({
                    editingIds: [],
                    addingIds: [],
                    editPropertyVisible: false,
                    editPropertyId: "",
                    editIds: [],
                    fieldName: "",
                    fieldType: 1,
                    ruleType: 0,
                    length: 0,
                    contentTypes: [],
                    keyValueMapsArr: [],
                    prohibitExit: false
                });
                recoverToDefault({
                    newMediaTypeId
                }, () => {
                    message.success("数据已恢复");
                    this.getList();
                });
            },
            cancelText: "取消",
            okText: "确认"
        });
    };

    // 保存所有
    saveAll() {
        let {
            dataSourceHold,
            dataSource,
            editingIds,
            addingIds,
            newMediaTypeId
        } = this.state;

        if (editingIds.length || addingIds.length) {
            message.error("当前存在数据正在编辑，请完成后再保存！");
            return false;
        }

        // 数据校验  校验 dataSourceHold
        for (let i = 0; i < dataSourceHold.length; i++) {
            const holdItem = dataSourceHold[i];
            if (holdItem.fieldName === "") {
                message.warn("字段名称不能为空，添加字段名称后再保存");
                return false;
            } else if (holdItem.dbFieldName === "") {
                message.warn("键不能为空，添加字段名称后再保存");
                return false;
            }
            for (let j = i + 1; j < dataSourceHold.length; j++) {
                const holdItemJ = dataSourceHold[j];
                if (holdItemJ.fieldName === holdItem.fieldName) {
                    message.error("字段名称不能重复，重复字段名称：" + holdItem.fieldName);
                    return false;
                } else if (holdItemJ.dbFieldName === holdItem.dbFieldName) {
                    message.error("键不能重复，重复键名称：" + holdItem.dbFieldName);
                    return false;
                }
            }
        }
        // 获取删除数据
        const delIds = [];
        dataSource.forEach(sourceItem => {
            const holdItemIndex = dataSourceHold.findIndex(holeItem => holeItem.id === sourceItem.id);
            if (holdItemIndex === -1) {
                delIds.push(sourceItem.id);
            }
        });

        // 批量删除
        if (delIds.length) {
            batchDeleteNewMediaField({
                newMediaFieldDefineIds: delIds,
                newMediaTypeId
            }, () => {
                message.success("保存成功");
            });
        }

        // 保存所有
        if (!dataSourceHold.length && !delIds.length) {
            message.error("当前没有数据可保存");
            return false;
        }
        if (dataSourceHold.length) {
            saveAllNewMediaFields({
                    newMediaFieldDefines: dataSourceHold,
                    newMediaTypeId
                },
                () => {
                    message.success("保存成功");
                });
        }
        dataSource = JSON.parse(JSON.stringify(dataSourceHold));
        this.setState({prohibitExit: false});
    };

    // keyValueMaps to array
    parseKeyValueMaps = (maps) => {
        const arr = [];
        Object.keys(maps).forEach(item => {
            arr.push({
                key: item,
                value: maps[item],
                id: Math.random()
            });
        });
        return arr;
    };

    // KeyValueMapsArr to map
    parseKeyValueMapsArr = (arr) => {
        const obj = {};
        arr.forEach(item => {
            obj[item.key] = item.value;
        });
        return obj;
    };
}
